module.exports = __webpack_public_path__ + "img/icon6.92f35df3.png";